import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';

import { GetInstanceCollaborators } from '../../store/actions';
import { getInstanceCollaborators$ } from '../../store/selectors';

@Component({
    selector: 'app-collaborators-dialog',
    templateUrl: './collaborators-dialog.component.html',
    styleUrls: ['./collaborators-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class CollaboratorsDialogComponent implements OnDestroy, OnInit {
    @Input() public record: any;

    private unSubscribe = new Subject<void>();
    public collaborators: any[];

    constructor(private store$: Store, private dialogRef: MatDialogRef<CollaboratorsDialogComponent>) {}

    private getCollaborations = () => {
        this.store$.dispatch(GetInstanceCollaborators({ instanceId: this.record?.recordId, assetId: this.record?.assetId }));
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    ngOnInit(): void {
        this.store$
            .select(getInstanceCollaborators$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(collaborators => {
                this.collaborators = CommonUtilsService.cloneObject(collaborators?.[this.record?.recordId]);
            });

        this.getCollaborations();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
